// --- DEVELOPMENT
export const baseUrl = window.location.origin;
export const compName = "Charles & Keith";
export const appName = "CK ONE";
export const appSubName = "";
// export const apiDomain = "http://127.0.0.1:5001/api/v1";
export const apiDomain = "https://ckonem.e-charleskeith.com/api/v1";
// export const apiDomain = "https://ckone-api.e-charleskeith.com:8443/ck-repl-api";


// --- PRODUCTION
// export const appName = "CK ONE";
// export const appSubName = "";
// export const apiDomain = "http://52.74.201.160:8082/app";



// WEBPACK FOOTER //
// ./src/.env.js